import * as React from "react";
import { forwardRef } from "react";
const SvgUpMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 15, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M19.565 11.733a3.8 3.8 0 0 1-.326 1.516 2.9 2.9 0 0 1-1.044 1.265c-.46.31-.997.479-1.548.485H2.92a2.83 2.83 0 0 1-1.548-.484c-.46-.31-.822-.75-1.044-1.265a3.57 3.57 0 0 1 .424-3.683l6.863-8.499c.26-.333.589-.602.964-.787a2.72 2.72 0 0 1 2.407 0c.376.185.706.454.965.787l6.864 8.499a3.48 3.48 0 0 1 .75 2.166" }));
const ForwardRef = forwardRef(SvgUpMenu);
export { ForwardRef as ReactComponent };
